import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
    imageListItem: {
        '&.MuiImageListItem-root': {
            flexDirection: 'row',
            alignItems: 'center',
            minHeight: '72px',
            paddingLeft: '16px',
            paddingRight: '16px',
        },
    },
    thumbnailContainer: {
        maxHeight: '56px',
        maxWidth: '56px',
    },
    thumbnailTitle: {
        '&.MuiTypography-root': {
            fontSize: '16px',
            fontWeight: '400',
            paddingLeft: '12px',
            paddingRight: '4px',
        },
    },
    categoryIcon: {
        '&.MuiSvgIcon-root': {
            height: '35px',
            width: '40px',
        },
    },
}));
